import { createFormAction } from "redux-form-saga";
export const SALE_FORM_KEY = 'ASSET_SALE_FORM'
export const AssetSaleFormAction = createFormAction(SALE_FORM_KEY)

